import React, { useState, useRef, useEffect } from 'react';
import AccountModal from '../AccountModal/AccountModal';
// Removed RoleManager import as it is no longer needed
import './DashboardHeader.css';
import PaymentMethodModal from '../PaymentMethodModal/PaymentMethodModal';

const DashboardHeader = ({ user, onLogout, onAccountSuccess, onPaymentMethodSuccess }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [isPaymentMethodsModalOpen, setIsPaymentMethodsModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleAccountInfoClick = () => {
    setIsDropdownOpen(false);
    setIsAccountModalOpen(true);
  };

  const handlePaymentMethodsClick = () => {
    setIsDropdownOpen(false);
    setIsPaymentMethodsModalOpen(true);
  };

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    onLogout();
  };

  const handleAccountModalClose = () => {
    setIsAccountModalOpen(false);
  };

  const handlePaymentMethodsModalClose = () => {
    setIsPaymentMethodsModalOpen(false);
  };

  const handleAccountUpdateSuccess = (message) => {
    setIsAccountModalOpen(false);
    if (onAccountSuccess) {
      onAccountSuccess(message);
    }
  };

  const handlePaymentMethodSuccess = (message) => {
    setIsPaymentMethodsModalOpen(false);
    if (onPaymentMethodSuccess) {
      onPaymentMethodSuccess(message);
    }
  };

  return (
    <>
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <h1>VerdictAse</h1>
          </div>

          <div className="header-right">
            <div className="user-info">
              <span className="user-name">Welcome, {user.name}</span>
            </div>

            <div className="user-dropdown" ref={dropdownRef}>
              <button
                className="dropdown-trigger"
                onClick={toggleDropdown}
                aria-expanded={isDropdownOpen}
                aria-haspopup="true"
              >
                <div className="user-avatar">{user.name.charAt(0).toUpperCase()}</div>
                <svg
                  className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                >
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none" />
                </svg>
              </button>

              {isDropdownOpen && (
                <div className="dropdown-menu">
                  <button className="dropdown-item" onClick={handleAccountInfoClick}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                    Account Information
                  </button>
                  <div className="dropdown-divider"></div>
                  <button className="dropdown-item" onClick={handlePaymentMethodsClick}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                    Payment Methods
                  </button>
                  <div className="dropdown-divider"></div>
                  <button className="dropdown-item logout" onClick={handleLogoutClick}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
                    </svg>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <AccountModal
        isOpen={isAccountModalOpen}
        onClose={handleAccountModalClose}
        onSuccess={handleAccountUpdateSuccess}
        user={user}
      />

      <PaymentMethodModal
        isOpen={isPaymentMethodsModalOpen}
        onClose={handlePaymentMethodsModalClose}
        onSuccess={handlePaymentMethodSuccess}
        userId={user.id}
      />
    </>
  );
};

export default DashboardHeader;
